import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 w-full h-full flex justify-center",
  style: {"background-color":"#999999aa"}
}

import { computed, onMounted, onUpdated, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Auth, Storage } from "aws-amplify";

import OpeningVideo from "@/components/OpeningVideo.vue";
import { boolean } from "yup/lib/locale";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// import { Options, Vue } from "vue-class-component";
// import store from "@/store";

const store = useStore();
const route = useRoute();

onMounted(async () => {
  // console.log(`matched: ${route.matched.some((record: RouteLocationMatched) => record.meta.requiresAuth)}`)
  // console.log(`path: ${route.path}`)
  // console.log(`fullPath: ${route.fullPath}`)
  // console.log(`query: ${route.query}`)
  // console.log(`hash: ${route.hash}`)
  // console.log(`name: ${String(route.name)}`)
  // console.log(`params: ${route.params}`)
  // console.log(`redirectedFrom: ${route.redirectedFrom}`)
  // console.log(`meta: ${route.meta.title}`)
});

const show_video = computed<boolean>(() => {
  return store.state.show_video;
});

const getShownVideo = () => {
  if (route.path == "/commerce" ||
    route.path == "/privacypolicy" ||
    route.path == "/termsofuse" ||
    route.path == "/login" || 
    route.path == "/invite") {
    throw false;
  }

  const v = sessionStorage.getItem('shown_video');
  if (!v) {
    return false;
  }

  return v == "true";
};

const onVideoHidden = () => {
  store.dispatch('markShownVideo');
};

// @Options({})
// export default class App extends Vue {
onMounted(() => {
  // console.log(route.path);
  if (route.path == "/" ||
    route.path == "/commerce" ||
    route.path == "/privacypolicy" ||
    route.path == "/termsofuse" ||
    route.path == "/login" || 
    route.path == "/invite"
  ) {
    return;
  }
  // console.log('refreshUser');
  // store.dispatch("refreshUser");
});

onUpdated(() => {
  // console.log(`onUpdated() [${route.path}]`);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_router_view)
    ]),
    (show_video.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(OpeningVideo, { onHidden: onVideoHidden })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})